var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0757 27.135C23.3941 27.12 22.8458 26.55 22.8458 25.86C22.831 25.17 23.3793 24.6015 24.0609 24.5865H24.0757C24.7722 24.5865 25.3353 25.1565 25.3353 25.86C25.3353 26.565 24.7722 27.135 24.0757 27.135ZM18.0296 21.615C17.348 21.6465 16.7849 21.105 16.7552 20.4165C16.7552 19.7265 17.2887 19.1565 17.9704 19.125C18.6372 19.125 19.1855 19.6515 19.2003 20.325C19.23 21.0165 18.6965 21.5865 18.0296 21.615ZM18.0296 27.06C17.348 27.0915 16.7849 26.55 16.7552 25.86C16.7552 25.17 17.2887 24.6015 17.9704 24.57C18.6372 24.57 19.1855 25.0965 19.2003 25.7715C19.23 26.4615 18.6965 27.0315 18.0296 27.06ZM11.9391 21.615C11.2574 21.6465 10.6943 21.105 10.6647 20.4165C10.6647 19.7265 11.1981 19.1565 11.8798 19.125C12.5467 19.125 13.095 19.6515 13.1098 20.325C13.1394 21.0165 12.6059 21.5865 11.9391 21.615ZM11.9243 27.06C11.2426 27.0915 10.6795 26.55 10.6498 25.86C10.6498 25.17 11.1833 24.6015 11.865 24.57C12.5318 24.57 13.0801 25.0965 13.095 25.7715C13.1246 26.4615 12.5911 27.0315 11.9243 27.06ZM22.8606 20.4015C22.8606 19.7115 23.3941 19.1565 24.0757 19.1415C24.7426 19.1415 25.2761 19.68 25.3057 20.3415C25.3205 21.0315 24.787 21.6015 24.1202 21.615C23.4385 21.63 22.8754 21.105 22.8606 20.4165V20.4015ZM4.5 13.8855V25.305C4.5 30.045 7.49341 33 12.191 33H23.7942C28.5362 33 31.5 30.105 31.5 25.3965V13.8855H4.5Z",
    fill: "url(#paint0_linear_1682_25835)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.505 13.8854C4.52427 13.0049 4.59836 11.2574 4.73766 10.6949C5.44897 7.53136 7.86445 5.52136 11.3172 5.23486H24.6839C28.107 5.53636 30.5522 7.55986 31.2635 10.6949C31.4013 11.2424 31.4754 13.0034 31.4946 13.8854H4.505Z",
    fill: "url(#paint1_linear_1682_25835)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4573 9.885C13.1093 9.885 13.5983 9.3915 13.5983 8.73V4.1565C13.5983 3.495 13.1093 3 12.4573 3C11.8052 3 11.3162 3.495 11.3162 4.1565V8.73C11.3162 9.3915 11.8052 9.885 12.4573 9.885Z",
    fill: "url(#paint2_linear_1682_25835)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5424 9.885C24.1796 9.885 24.6835 9.3915 24.6835 8.73V4.1565C24.6835 3.495 24.1796 3 23.5424 3C22.8904 3 22.4014 3.495 22.4014 4.1565V8.73C22.4014 9.3915 22.8904 9.885 23.5424 9.885Z",
    fill: "url(#paint3_linear_1682_25835)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1682_25835",
    x1: 18,
    y1: 13.8855,
    x2: 18,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD51E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1682_25835",
    x1: 17.9998,
    y1: 5.23486,
    x2: 17.9998,
    y2: 13.8854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD51E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1682_25835",
    x1: 12.4573,
    y1: 3,
    x2: 12.4573,
    y2: 9.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD51E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1682_25835",
    x1: 23.5424,
    y1: 3,
    x2: 23.5424,
    y2: 9.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD51E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#701B96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKalender);
export default __webpack_public_path__ + "static/media/kalender.fd8face4f3e6e06d03cac94607b2de55.svg";
export { ForwardRef as ReactComponent };